import React, { useState } from 'react';
import Modal from 'react-modal';
import { loadStripe, PaymentIntent } from "@stripe/stripe-js";

import { graphqlSchema } from '../../../services/graphql.schema';

import './Account.payment.choose.scss';
import { PaymentMethodOption, StripePaymentIntentResponse } from '../../../models/Stripe';
import AccountPaymentChooseView from './Account.payment.choose';
import AccountPaymentPayIntent from './Account.payment.payIntent';
import { STRIPE_PUBLISHABLE_KEY } from '../../../services/shared.stripe';
import { useMutation } from '@apollo/client';

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        maxHeight: '80vh',
        maxWidth: '500px',
        padding: '0px',
        border: 'none',
        borderRadius: '16px',
        boxShadow: '3px 4px 15px rgba(170, 170, 208, 0.5)'
    }
};

interface AccountPaymentProps {
    isOpen: boolean;
    onRequestClose: (response?: {success: boolean}) => void;
}


function AccountPayment({ isOpen, onRequestClose }: AccountPaymentProps) {
    const [payMethod, setPayMethod] = useState<PaymentMethodOption>('stripe');
    const [loading, setLoading] = useState<boolean>(false);
    // Stripe Payment Intents
    const [paymentIntent, setPaymentIntent] = useState<StripePaymentIntentResponse | null>(null);

    const [createPaymentIntent] = useMutation(graphqlSchema.STRIPE.PAYMENTS.createPaymentIntent, {
        onCompleted: ({ createPaymentIntent }: {
            createPaymentIntent: StripePaymentIntentResponse
        }) => {
            console.log('Payment Intent Created: ', createPaymentIntent);
            setLoading(false);
            // Map snake_case to camelCase
            setPaymentIntent(createPaymentIntent);
        },
        onError: (e) => {
            setLoading(false);
            console.error('Error creating payment intent: ', e);
        }
    })

    const handleMethodChange = (option: PaymentMethodOption) => {
        setPayMethod(option);
    }

    const requestMoreCredit = (paymentMethod: PaymentMethodOption, amount: number) => {
        console.log('Requesting more credit with method: ', paymentMethod, amount);
        if (paymentMethod === 'stripe') {
            // CREATE STRIPE PAYMENT INTENT
            setLoading(true);
            createPaymentIntent({
                variables: {
                    amount: amount,  // Received as pesos, processed as cents
                }
            });
        }
    }

    const handlePaymentSuccess = (paymentIntent: PaymentIntent) => {
        // Payment successful, refresh and close
        console.log('Payment successful: ', paymentIntent);
        setLoading(false);
        setPaymentIntent(null);
        onRequestClose({ success: true });
    }

    const handlePaymentCancel = () => {
        // Cancel payment, go back to method selection
        setPaymentIntent(null);
        setPayMethod('stripe');
    }

    const requestClose = () => {
        // Apply some closing locks or checks here, if needed
        if(loading) return;
        setPaymentIntent(null);
        setPayMethod('stripe');
        onRequestClose();
    }


    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={requestClose}
            shouldCloseOnOverlayClick={false}
            style={customStyles}
            ariaHideApp={false}
            contentLabel="Producto Edit Modal"
        >
            {paymentIntent ? (
                <AccountPaymentPayIntent
                    clientSecret={paymentIntent.client_secret}
                    amountCents={paymentIntent.amountCents}
                    stripePromise={stripePromise}
                    onSuccess={handlePaymentSuccess}
                    onCancel={handlePaymentCancel}
                />
            ) : (
                <AccountPaymentChooseView
                    payMethod={payMethod}
                    handleMethodChange={handleMethodChange}
                    requestMoreCredit={requestMoreCredit}
                    requestClose={requestClose}
                    loading={loading}
                />
            )}
        </Modal>
    )
}

export default AccountPayment;